import { jsonInit, toSearchParams } from '@shigo-ui/api-client';

import { createShigoApiClient, type ShigoApiConfig } from '../../../lib/shigo-api-client';
import {
  StitcherAccessFilter,
  stitcherAccessPageSchema,
  stitcherAccessUserSchema,
  type StitcherAccessFilterValue,
} from './model';

type StitcherAccessClientOptions = {
  config: ShigoApiConfig;
  accessToken: string;
  fetcher?: typeof fetch;
};

export function createStitcherAccessClient({
  config,
  accessToken,
  fetcher,
}: StitcherAccessClientOptions) {
  const api = createShigoApiClient(config, accessToken, fetcher);

  return {
    list: (filter: StitcherAccessFilterValue) =>
      api.request({
        path: `/api/sa/stitcher-access?${toSearchParams({
          searchTerm: filter.searchTerm.trim() || undefined,
          useStitcher: filter.access === StitcherAccessFilter.Granted ? true : undefined,
          page: filter.page,
          size: filter.size,
        })}`,
        schema: stitcherAccessPageSchema,
      }),
    setUseStitcher: (userId: string, useStitcher: boolean) =>
      api.request({
        path: `/api/sa/stitcher-access/${encodeURIComponent(userId)}`,
        schema: stitcherAccessUserSchema,
        init: jsonInit('PUT', { useStitcher }),
      }),
  };
}
